import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { connect } from 'react-redux'
import { Grid, InputLabel, MenuItem, Select, styled } from '@mui/material'
import { FormControlRow, InputRow } from '../styled/inputs'
import DtoVariousMatType from '../../referencials/installations/dto/DtoVariousMatType'
import { getSetting } from '../../../../utils/FormUtils'
import { hasValue } from '../../../../utils/NumberUtil'
import { getDate } from '../../../../utils/DateUtil'
import EditableCard from './EditableCard'
import StyledCard from './StyledCard'
import { ReactComponent as EditLogo } from '../../../../ressources/static/svg/Editer.svg'
import DtoSandreCode from '../../referencials/dto/DtoSandreCode'
import { getSandreLabel } from '../../../../utils/StringUtil'

const Container = styled(Grid)({
    margin: '8 0',
})

class ComptageCard extends Component {
    getContent = (editMode, data) => {
        const { variousMatTypes, applicationSettings, codesSandre } = this.props

        const materielReadingCoeffEntry = getSetting(applicationSettings, 'materielReadingCoeffEntry')
        if (editMode) {
            return (
                <>
                    <InputRow item id='type' label={i18n.type} type='text' variant='outlined' />
                    <InputRow item id='ref' label={i18n.ref} type='text' variant='outlined' />
                    <InputRow item id='marque' label={i18n.marque} type='text' variant='outlined' />
                    <InputRow
                        item
                        id='poseYear'
                        label={i18n.installationDate}
                        type='number'
                        variant='outlined'
                    />
                    <InputRow
                        item
                        id='revisionDate'
                        label={i18n.revisionDate}
                        type='number'
                        variant='outlined'
                    />
                    {materielReadingCoeffEntry === '1' || data.materielType === 10 ? (
                        <FormControlRow variant='outlined'>
                            <InputLabel>{i18n.coefLecture}</InputLabel>
                            <Select
                                id='readingCoefficient'
                                label={i18n.coefLecture}
                            >
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                            </Select>
                        </FormControlRow>
                    ) : (
                        <InputRow
                            item
                            id='maxFlow'
                            variant='outlined'
                            label={i18n.coefLecture}
                            type='number'
                        />
                    )}
                    <InputRow
                        item
                        id='sharedDispositif'
                        label={i18n.sharedDispositif}
                        type='text'
                        variant='outlined'
                    />
                    <InputRow
                        item
                        id='comment'
                        label={i18n.comment}
                        type='text'
                        variant='outlined'
                    />
                    <InputRow
                        item
                        id='incident'
                        label={i18n.incident}
                        type='text'
                        variant='outlined'
                    />
                    <InputRow
                        item
                        id='dateReleve'
                        label={i18n.dateReleve}
                        type='text'
                        variant='outlined'
                    />
                    <InputRow item id='index' label={i18n.index} type='text' variant='outlined' />
                </>
            )
        }
        const counterType = variousMatTypes.find((t) => t.materielType === data.materielType)
        return (
            <>
                <Container>{i18n.name} : {data.name || ''}</Container>
                <Container>{i18n.type} : {counterType ? counterType.name : ''}</Container>
                <Container>{i18n.marque} : {data.brand || ''}</Container>
                <Container>{i18n.reference} : {data.serialNumber || ''}</Container>
                <Container>{i18n.coefLecture} : {data.readingCoefficient || ''}</Container>
                <Container>{i18n.mobility} : {getSandreLabel(codesSandre, 'MAT.MOBILITE', data.mobilityCode) || ''}</Container>
                <Container>{i18n.installationDate} : {getDate(data.installationDate) || ''}</Container>
                <Container>{i18n.revisionDate} : {getDate(data.revisionDate) || ''}</Container>
                <Container>{i18n.tauxAffectation} : {hasValue(data.assignmentRate) ? `${data.assignmentRate}%` : ''}</Container>
                <Container>{i18n.sharedDispositif} : {data.isShared ? i18n.yes : i18n.no}</Container>
                <Container>{i18n.informative} : {data.informative ? i18n.yes : i18n.no}</Container>
                <Container>{'IAM'} : {data.provenImpossibility ? i18n.yes : i18n.no}</Container>
                <Container>{i18n.agencyDecisionDate} : {data.agencyDecisionDate ? getDate(data.agencyDecisionDate) : ''}</Container>
                {hasValue(data.comment) && <Container>{i18n.comment} : {data.comment || ''}</Container>}
            </>
        )
    }

    render() {
        const { title, editMode, hideIcon, data, colorTitle, newStyle, variousMatTypes, codesSandre } = this.props
        if (newStyle) {
            const matType = variousMatTypes.find((t) => t.materielType === data.materielType)
            const style = { padding: 10, borderTop: '1px solid black' }
            return (
                <StyledCard
                    subTitle={(
                        <Grid container justifyContent='space-between' alignItems='center'>
                            {title}
                            {!hideIcon && <EditLogo fill='black' className='clickable' style={{ height: 30 }} onClick={this.props.toggleEditMode} />}
                        </Grid>
                    )}
                    styleContainer={{ padding: 0 }}
                    styleContent={{ padding: 0 }}
                    styleSubTitle={{ borderTop: '1px solid black', display: 'flex', justifyContent: 'space-between' }}
                >
                    <Grid container style={{ padding: 10 }}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.name}</Grid>
                        <Grid item xs={6} className='bold'>{data?.name || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.type}</Grid>
                        <Grid item xs={6} className='bold'>{matType?.name || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.marque}</Grid>
                        <Grid item xs={6} className='bold'>{data?.brand || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.reference}</Grid>
                        <Grid item xs={6} className='bold'>{data?.serialNumber || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.coefLecture}</Grid>
                        <Grid item xs={6} className='bold'>{data?.readingCoefficient || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.mobility}</Grid>
                        <Grid item xs={6} className='bold'>{getSandreLabel(codesSandre, 'MAT.MOBILITE', data.mobilityCode) || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.installationDate}</Grid>
                        <Grid item xs={6} className='bold'>{getDate(data?.installationDate) || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.revisionDate}</Grid>
                        <Grid item xs={6} className='bold'>{getDate(data?.revisionDate) || '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.tauxAffectation}</Grid>
                        <Grid item xs={6} className='bold'>{hasValue(data.assignmentRate) ? `${data.assignmentRate}%` : '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.sharedDispositif}</Grid>
                        <Grid item xs={6} className='bold'>{data.isShared ? i18n.yes : i18n.no}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.informative}</Grid>
                        <Grid item xs={6} className='bold'>{data.informative ? i18n.yes : i18n.no}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{'IAM'}</Grid>
                        <Grid item xs={6} className='bold'>{data.provenImpossibility ? i18n.yes : i18n.no}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.agencyDecisionDate}</Grid>
                        <Grid item xs={6} className='bold'>{data.agencyDecisionDate ? getDate(data.agencyDecisionDate) : '-'}</Grid>
                    </Grid>
                    <Grid container style={style}>
                        <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.comment}</Grid>
                        <Grid item xs={6} className='bold'>{data?.comment || '-'}</Grid>
                    </Grid>
                </StyledCard>
            )
        }
        return (
            <EditableCard
                title={title}
                editMode={editMode}
                toggleEditMode={this.props.toggleEditMode}
                hideIcon={hideIcon}
                colorTitle={colorTitle}
            >
                {this.getContent(editMode, data)}
            </EditableCard>
        )
    }
}

ComptageCard.propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    editMode: PropTypes.bool,
    colorTitle: PropTypes.string,
    selectType: PropTypes.bool,
    hideIcon: PropTypes.bool,
    newStyle: PropTypes.bool,
    toggleEditMode: PropTypes.func,
    variousMatTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoVariousMatType)),
    applicationSettings: PropTypes.arrayOf(PropTypes.shape({})),
    codesSandre: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
}

ComptageCard.defaultProps = {
    editable: false,
}

const mapStateToProps = (store) => {
    return {
        variousMatTypes: store.InstallationsReducer.variousMatTypes,
        applicationSettings: store.HomeReducer.applicationSettings,
        codesSandre: store.ReferencialReducer.codesSandre,
    }
}

export default connect(mapStateToProps)(ComptageCard)
